import { notificationsState, setNotificationsStateById } from '../NotificationsContext';

export const updateNotificationsContext =
  (setStateById: setNotificationsStateById) => (newState: Partial<typeof notificationsState>) => {
    setStateById('UPDATE_CONTEXT', (s) => ({
      ...s,
      ...newState,
    }));
  };
